import { render, staticRenderFns } from "./ExclusionRules.vue?vue&type=template&id=6fb1fc3d&scoped=true&"
import script from "./ExclusionRules.vue?vue&type=script&lang=js&"
export * from "./ExclusionRules.vue?vue&type=script&lang=js&"
import style0 from "./ExclusionRules.vue?vue&type=style&index=0&id=6fb1fc3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1fc3d",
  null
  
)

export default component.exports